import React, { createContext, useContext, useEffect, useState } from 'react';
import { 
  GoogleAuthProvider, 
  signInWithPopup, 
  signOut, 
  onAuthStateChanged 
} from 'firebase/auth';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { auth, db } from '../firebase';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
      setError(null);
    });

    return unsubscribe;
  }, []);

  const isEmailAllowed = async (email) => {
    try {
      console.log('Checking if email is allowed:', email);
      const allowedEmailsRef = collection(db, 'allowedEmails');
      const q = query(allowedEmailsRef, where('email', '==', email));
      const querySnapshot = await getDocs(q);
      console.log('Query results:', querySnapshot.empty ? 'No matches found' : 'Match found');
      return !querySnapshot.empty;
    } catch (error) {
      console.error('Error checking allowed emails:', error);
      throw error;
    }
  };

  const signInWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      console.log('User signed in with email:', result.user.email);
      
      const isAllowed = await isEmailAllowed(result.user.email);
      console.log('Is email allowed?', isAllowed);
      
      if (!isAllowed) {
        console.log('Email not allowed, signing out...');
        await signOut(auth);
        throw new Error('Your email is not authorized to access this application.');
      }
      
      return result.user;
    } catch (error) {
      console.error('Error in signInWithGoogle:', error);
      setError(error.message);
      throw error;
    }
  };

  const logout = async () => {
    try {
      await signOut(auth);
      setError(null);
    } catch (error) {
      console.error('Error signing out:', error);
      throw error;
    }
  };

  const value = {
    user,
    error,
    signInWithGoogle,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
} 